export default "__VITE_ASSET__CmL6FoWz__"